import React, {FC} from 'react';
import {InformationLineFc} from './InformationLine';

const NoPermissionFc: FC = () => {
  return <InformationLineFc description={'You have no permissions to access this section.'} />;
};

export default NoPermissionFc;
